import React from "react";
import Box from "@mui/material/Box";
import { Typography, useTheme } from "@mui/material";
import { fluxTutorialsVideos } from "../../Dashboard/fluxTutorialsData";
import ReactPlayer from "react-player";

const FluxTutorials: React.FC = () => {
  const theme = useTheme();
  const { semanticColors } = theme;

  const renderVideos = () => {
    return fluxTutorialsVideos.map(({ videoUrl, title, playlistUrl }, i) => (
      <Box
        sx={{
          background: semanticColors.surface,
          border: `1px solid ${semanticColors.borderSecondary}`,
          borderRadius: "8px",
          padding: "10px",
          width: "400px",
          flexShrink: 0,
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
        key={videoUrl + i}
      >
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            width: "100%",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <ReactPlayer
              url={videoUrl}
              controls
              playing={false}
              width="100%"
              height="100%"
            />
          </Box>
        </Box>
        <Box sx={{ flexShrink: 0, marginTop: "10px" }}>
          <Typography
            sx={{
              color: semanticColors.textPrimary,
              fontWeight: 500,
              padding: "5px 0",
              fontSize: "14px",
            }}
          >
            {title}
          </Typography>
          <Typography
            sx={{
              color: semanticColors.textTertiary,
              fontSize: "14px",
              fontWeight: 400,
            }}
          >
            Learn more:{" "}
            <a
              href={playlistUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: semanticColors.textSecondary }}
            >
              view full playlist
            </a>
          </Typography>
        </Box>
      </Box>
    ));
  };

  return (
    <Box
      sx={{
        borderRadius: "8px",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "stretch",
          gap: "10px",
          overflowX: "auto",
          overflowY: "hidden",
          width: "100%",
          flex: 1,
          minHeight: 0,
          maxHeight: "100%",
          padding: "10px 0",
          paddingBottom: "32px",
          "&::-webkit-scrollbar": {
            width: "6px",
            height: "6px",
          },
        }}
      >
        {renderVideos()}
      </Box>
    </Box>
  );
};

export default FluxTutorials;
